<template>
  <generic-modal :title="$t('requested trip')" ref="generic_modal">
    <div class="form">
      <pre>{{ meta }}</pre>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("destination") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.destination" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("date") }}</label>
            <div class="control">
              <input class="input" type="date" v-model="meta.date" />
            </div>
          </div>
        </div>
        <!-- <div class="column"></div> -->
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <!--<button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button> -->
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  confirm_deletion_dialog,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import moment from "moment";

export default {
  name: "EventModal",
  components: { GenericModal, GenericCalendar, GenericDropdown },
  data() {
    return {
      meta: { settings: {} },
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.destination ||
        !v.meta.departure_date ||
        !v.meta.return_date ||
        !v.meta.driver_id ||
        !v.meta.vehicle_id
      );
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    create_event(args) {
      let v = this;
      v.set_initial_state();
      // v.$refs.start_date_calendar.set_date(args.date);
      v.meta.departure_date = args.date;
      let end_date = moment(args.date).add(1, "hour");
      // v.$refs.end_date_calendar.set_date(end_date);
      v.meta.return_date = end_date;
      v.$refs.generic_modal.show_modal();
    },
    view_event(event_uuid) {
      let v = this;
      v.set_initial_state();

      if (event_uuid) {
        // v.uuid = product_uuid;
        get("/trip/request", { uuid: event_uuid })
          .then((event) => {
            v.meta = event;
            console.log(event);

            v.$refs.generic_modal.show_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else v.$refs.generic_modal.show_modal();
    },
    // save() {
    //   let v = this;
    //   if (!v.meta.uuid)
    //     put("/trip/scheduled", v.meta)
    //       .then(() => {
    //         v.$emit("success");
    //         v.$refs.generic_modal.close_modal();
    //       })
    //       .catch((error) => {
    //         v.error = generate_error_message_text(error);
    //       });
    //   else
    //     post("/trip/scheduled", v.meta)
    //       .then(() => {
    //         v.$emit("success");
    //         v.$refs.generic_modal.close_modal();
    //       })
    //       .catch((error) => {
    //         v.error = generate_error_message_text(error);
    //       });
    // },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
    remove() {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete trip?"), v, () => {
        del("/trip/request", { uuid: v.meta.uuid })
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
